define('reducer-entity',['exports', 'training', 'user-answers', 'store-helper-get-content', 'store-helper-get-props'], function (exports, _training, _userAnswers, _storeHelperGetContent, _storeHelperGetProps) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _training2 = _interopRequireDefault(_training);

    var _userAnswers2 = _interopRequireDefault(_userAnswers);

    var _storeHelperGetContent2 = _interopRequireDefault(_storeHelperGetContent);

    var _storeHelperGetProps2 = _interopRequireDefault(_storeHelperGetProps);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];


        switch (action.type) {
            case 'SET_ENTITY':
                {
                    var _action$payload = action.payload,
                        payload = _action$payload === undefined ? {} : _action$payload;


                    var training = new _training2.default(),
                        userAnswers = new _userAnswers2.default(),
                        entity = training.getEntity(payload.ID) || {},
                        content = (0, _storeHelperGetContent2.default)(action.training, training, entity);

                    if (!content) {
                        return state;
                    }

                    return Object.assign({}, state, content, {
                        props: (0, _storeHelperGetProps2.default)(action.training, training, content, userAnswers)
                    });
                }
            case 'SET_ENTITY_ACTIVE':
                {
                    return Object.assign({}, state, {
                        props: Object.assign({}, state.props, {
                            isInactive: false
                        })
                    });
                }
            default:
                return state;
        }
    };
});
